import { getServerRequestContext } from '@coolblue-development/next-request-context/server';
import { getClickableT } from '../client/utils/getClickableT.js';
import { getI18nInstance } from './getI18nInstance.js';
import { getNamespace } from './getNamespace.js';
import { isTranslationInfoEnabled } from './Tool/isTranslationInfoEnabled.js';
export const getServerTranslationHook = ({ resource }) => {
    return async function (prefix) {
        const { language } = await getServerRequestContext();
        const i18nInstance = await getI18nInstance(language);
        const t = i18nInstance.getFixedT(i18nInstance.language, getNamespace(i18nInstance), `${resource}.${prefix}`);
        if (await isTranslationInfoEnabled()) {
            const clickableT = getClickableT({ t, resource, prefix });
            return { t: clickableT };
        }
        return { t };
    };
};
//# sourceMappingURL=getServerTranslationHook.js.map